export const APP_ENV = process.env.REACT_APP_ENV || 'lower';

export const IS_PROD_ENV = APP_ENV === 'prod';

export const getEnvValue = (key, fallback = '') => process.env[key] || fallback;
